'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './calendar-list.routes';

export class CalendarListComponent {

  constructor(CalendarEventService, $uibModal, $timeout, Auth, $state, TaskService, ViolationTicketsService, WorkOrderTicketsService,
              $scope, ViewSelection) {
    'ngInject';

    this.Auth = Auth;
    this.eventSources = [];
    this.$uibModal = $uibModal;
    this.$timeout  = $timeout;
    this.isAdmin = () => true;
    this.loading = true;

    this.display = {
      "task": true,
      "event": true,
      "wo": true,
      "ccr": true
    };

    this.type = "event";

    this.calendarConfig = {
      "event": {
        "color": "#ffcc66",
          "textColor": "black"
      },
      "task": {
        "color": "#aaf",
          "textColor": "black"
      }
    };
    this.calendarEventUserContributionAllowed = ["event"];

    this.timezone = "America/New_York";

    var eventSourceEvents = {
      events: [],
      color: '#228B22',
      textColor: 'white'
    };

    var eventSourceTasks = {
      events: [],
      color: '#446e9b',
      textColor: 'white'
    };

    var eventSourceViolations = {
      events: [],
      color: '#d9534f',
      textColor: 'white'
    };

    var eventSourceWorkOrders = {
      events: [],
      color: '#DAA520',
      textColor: 'white'
    };

    this.eventSources.push(eventSourceEvents);
    this.eventSources.push(eventSourceTasks);
    this.eventSources.push(eventSourceViolations);
    this.eventSources.push(eventSourceWorkOrders);

    $scope.ViewSelection = ViewSelection;
    $scope.$watch('ViewSelection.selectedCommunity', (newVal, oldVal, scope) => {
      this.selectedCommunity = newVal.name;
      this.selectedCommunityCode = newVal.value;

      if (maxResCount == resCount)
        this.filterData(this.selectedCommunityCode);
    });

    this.filterData = (code) => {
      console.log("enter filderData");
      if (code) {
        this.filteredData.workorder = this.data.workorder.filter(wo =>
          (wo.workOrderData && wo.workOrderData.community && wo.workOrderData.community.code == code)
          ||  (wo.workOrderData && wo.workOrderData.property && wo.workOrderData.property.community && wo.workOrderData.property.community.code == code)
        );

        this.filteredData.violation = this.data.violation.filter(ccr =>
          (ccr.violationData && ccr.violationData.property && ccr.violationData.property.community && ccr.violationData.property.community.code == code)
        );

        //TODO: Filter Tasks with target object in mind
        this.filteredData.task = this.data.task;
        this.filteredData.event = this.data.event;
      } else {
        this.filteredData.workorder = this.data.workorder;
        this.filteredData.violation = this.data.violation;
        this.filteredData.task = this.data.task;
        this.filteredData.event = this.data.event;
      }

      if (!this.display.task)
        this.filteredData.task = [];
      if (!this.display.event)
        this.filteredData.event = [];
      if (!this.display.wo)
        this.filteredData.workorder = [];
      if (!this.display.ccr)
        this.filteredData.violation = [];

      for (let i=0; i<=3; i++) { // cleanup
        if (this.eventSources.length && this.eventSources[i].events.length) {
          this.eventSources[i].events.splice(0, this.eventSources[i].events.length);
        }
      }

      this.filteredData.workorder.forEach(wo => {
        this.eventSources[3].events.push(wo);
      });

      this.filteredData.violation.forEach(ccr => {
        this.eventSources[2].events.push(ccr);
      });

      this.filteredData.task.forEach(task => {
        this.eventSources[1].events.push(task);
      });

      this.filteredData.event.forEach(event => {
        this.eventSources[0].events.push(event);
      });

      this.loading = false;

      this.$timeout(() => {
        jQuery('#fullCalendar').fullCalendar('removeEvents');
        this.eventSources.forEach(eventSource => {
          jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
        });
      },0);
    };

    var that = this;

    this.data = {
      workorder: [],
      violation: [],
      task: [],
      event: []
    };

    this.filteredData = {
      workorder: [],
      violation: [],
      task: [],
      event: []
    };

    let resCount = 0;
    let maxResCount = 4;

    var getData = () => {
      WorkOrderTicketsService.query(data => {

        let targetData = data.filter(wo => wo.hasOwnProperty("targetDate"));

        targetData.forEach(wo => {
          this.data.workorder.push({
            title: wo.code + ": " + wo.name,
            description: wo.description,
            start: moment(wo.targetDate),
            end: '',
            allDay: true,
            type: "workorder",
            workOrderData: wo
          });
        });

        resCount++;
        if (resCount == maxResCount)
          this.filterData(this.selectedCommunityCode);
      });

      TaskService.query(data => {

        data.forEach(task => {
          this.data.task.push({
            title: task.subject,
            description: task.description,
            start: moment(task.dueDate),
            end: '',
            allDay: true,
            type: "task",
            taskData: task
          });
        });

        resCount++;
        if (resCount == maxResCount)
          this.filterData(this.selectedCommunityCode);
      });

      ViolationTicketsService.query(data => {
        data.forEach(ccr => {

         ccr.sequence.forEach(lvl => {
            let dueDate = moment(ccr.meta.creationDate, "YYYY-MM-DD").add(lvl.days, 'days').toDate();
            this.data.violation.push({
              title: ccr.code + ': ' + ccr.name + " / " + lvl.level,
              description: ccr.article,
              start: dueDate,
              end: '',
              allDay: true,
              type: "violation",
              violationData: ccr,
              levelData: lvl
            });
          });

        });

        resCount++;
        if (resCount == maxResCount)
          this.filterData(this.selectedCommunityCode);
      });

      CalendarEventService.getByType({type: that.type}, data => {

        if (that.eventSources.length && that.eventSources[0].events.length) {
          that.eventSources[0].events.splice(0, that.eventSources[0].events.length);
        }

        data.forEach(evt => {

          var event = evt;
          event.eventId = evt._id;

          if (event.isRecurring) {
            event.range = {start: event.start, end: event.recurrence.until};

            event.start = moment(event.start).format("HH:mm");

            if (event.end)
              event.end = moment(event.end).format("HH:mm");

            event.dow = event.recurrence.dayOfWeek;
            event.id = event._id;
          }

          this.data.event.push(event);
        });

        resCount++;
        if (resCount == maxResCount)
          this.filterData(this.selectedCommunityCode);

      }, err => {
        console.log('could not retrieve events from server');
      });

    };

    this.getData = getData;
    getData();

    this.uiConfig = {
      calendar: {
        timezone: 'local',
        header: {
          left: 'title',
          center: 'month,agendaWeek,listMonth',
          right: 'today prev,next'
        },
       viewRender: (view, el) => {
         jQuery('#fullCalendar').fullCalendar('removeEvents');
         this.eventSources.forEach(eventSource => {
          jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
         })
        },
        eventRender: (event, el) => {

          // Recurring Events
          if (event.isRecurring) {
            if (! (event.start.isBefore(event.range.end) && event.start.isAfter(event.range.start)) )
              return false;
          }

          // Timezone Difference Info
          var timeZoneDiffMin = this.getTimezoneDifference(this.timezone);

          var getTimezoneDiffString = function(mins) {
            var prefix = "+";
            if (mins < 0)
              prefix = "-";

            mins = Math.abs(mins);

            var h = mins / 60 | 0,
                m = mins % 60 | 0;

            if (String(h).length == 1)
              h = "0" + String(h);

            if (String(m).length == 1)
              m = "0" + String(m);

            return prefix + String(h) + ":" + String(m);
          };

          var timeZoneDiffStr = getTimezoneDiffString(timeZoneDiffMin);

          // render the timezone offset below the event title, if
          // user is in other timezone and the event is not all day
          if (!event.allDay && timeZoneDiffMin != 0) {
            el.find('.fc-title').after(
              jQuery('<div class="tzo text-muted"/>').text( timeZoneDiffStr )
            );
          }
        },
        eventClick: (calendarEvent, jsEvent, view) => {

          var that = this;

          if (calendarEvent.type == 'task') {
            var modalInstance = this.$uibModal.open({
              animation: true,
              component: 'taskShow',
              resolve: {
                config: function () {
                  return {
                    data: calendarEvent.taskData
                  }
                }
              },
              size: 'md'
            });
          } else if (calendarEvent.type == 'workorder') {
            var modalInstance = this.$uibModal.open({
              animation: true,
              component: 'workOrderShow',
              resolve: {
                config: function() {
                  return {
                    workOrder: calendarEvent.workOrderData
                  }
                }
              },
              size: 'md'
            });
          } else if (calendarEvent.type == 'violation') {
            var modalInstance = this.$uibModal.open({
              animation: true,
              component: 'violationShow',
              resolve: {
                config: function() {
                  return {
                    violation: calendarEvent.violationData,
                    level: calendarEvent.levelData,
                    levelDate: calendarEvent.start
                  }
                }
              },
              size: 'md'
            });
          } else {
            var modalInstance = this.$uibModal.open({
              animation: true,
              component: 'calendarEventDetail',
              resolve: {
                calendarEvent: function () {
                  return calendarEvent;
                },
                config: function() {
                  return {
                    userHasPermission: that.Auth.isAdminSync()
                    || (that.Auth.getCurrentUserSync()._id === calendarEvent.meta.creationUser)
                  }
                }
              }
            });

            modalInstance.result.then(
              function (result) {

                if (result.action === 'removed') {
                  that.$timeout(() => {
                    that.getData();
                  },0);
                }

              },
              function () { }
            );
          }



        }
      }
    };
  }

  doFilterData() {
    this.loading = true;
    this.$timeout(() => {
      this.filterData(this.selectedCommunityCode);
    },0);
  }

  userContributionAllowed() {
    return this.calendarEventUserContributionAllowed
      && this.calendarEventUserContributionAllowed.indexOf(this.type) !== -1;
  }

  getTimezoneDifference(targetTimezone, userTimezone) {
    var now = moment();

    if (typeof userTimezone != 'undefined') {
      now = moment.tz(userTimezone);
    }

    var localOffset = now.utcOffset();

    now.tz(targetTimezone);

    var centralOffset = now.utcOffset();
    var diffInMinutes = localOffset - centralOffset;

    return diffInMinutes;
  }

}

export default angular.module('conduuApp.calendarList', [uiRouter])
  .config(routes)
  .component('calendarList', {
    template: require('./calendar-list.html'),
    controller: CalendarListComponent,
    bindings: {},
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/calendar/list/calendar-list.component.js